<template>
  <div>
    <div style="float: right" class="text-xs-right">
      <v-btn icon @click="$emit('close')"> <v-icon>close</v-icon></v-btn>
    </div>
    <div class="pa-5 pt-1">
      <v-data-table
        :headers="headers"
        :items="activityLog"
        hide-actions
        :items-per-page="5"
        class="elevation-1"
      >
        <template #items="props">
          <td>
            {{ moment.utc(props.item.timestamp).add(7, 'hours').format('DD/MM/YYYY HH:mm') }}
          </td>
          <td>{{ props.item.action }}</td>
          <td>{{ props.item.action_by }}</td>
          <td>{{ props.item.role }}</td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  components: {},
  props: ['activityLog'],
  data() {
    return {
      headers: [
        { text: 'วันที่ดำเนินกิจกรรม', value: 'timestamp', sortable: false },
        { text: 'กิจกรรม', value: 'activity', sortable: false },
        { text: 'ผู้ดำเนินกิจกรรม', value: 'adminid', sortable: false },
        { text: 'บทบาท', value: 'role', sortable: false }
      ]
    }
  },
  computed: {
    moment() {
      return moment
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss">
.showcarouselall div span {
  /* Your style */
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/ActivityLog.vue